import { prependSlash } from '@repo/ui/src/components/Anchor/helpers';

const buildLinkObj = (link: any) => {
  const linkObj = {
    text: link?.displayName ?? '',
    href: 'link-not-set-amp',
    noFollow: link?.noFollow ?? false,
    noIndex: link?.noFollow ?? false,
  };
  if (link?.link != null) {
    linkObj.href = prependSlash<string>(link.link) ;
  } else if (link?.isExternal) {
    linkObj.href = link.externalLink;
  }
  return linkObj;
};

export const getRel = (linkObj: any) => {
  let rel = '';
  rel += linkObj.noFollow ? 'nofollow ' : '';
  rel += linkObj.noIndex ? 'noindex ' : '';
  return rel;
};

export default buildLinkObj;
